
export default {
  state: () => ({
    processes: null,
  }),
  mutations: {
    setProcesses(state, processes) {
      state.processes = processes;
    },
  },
  getters: {
    getProcesses: (state) => state.processes,
  },
  actions: {
    async makeProcesses({ commit }, processes) {
      if(!processes) {
        return;
      }
      let obj = {}
      processes.forEach((process) => {
        obj[process.processName] = {...process}
      })
      commit('setProcesses', obj)
    },
    async updateProcesses({ rootState, commit }, process) {
      if (!process || !process.processName) return;
      const obj =  { ...rootState.process.processes }
      obj[process.processName] = { ...process };
      commit('setProcesses', obj)
    },
  }
}